import pdpCustomPersonalization from "./rbmc.pdp-custom-personalization";
import pdpBlacklist from "./rbmc.pdp-blacklist";
import 'slick-carousel';
import pdpSlider from "./rbmc.pdp-slider";
import pdpLoadProduct from "./rbmc.pdp-load-product";
import pdpPlayerPersonalization from "./rbmc.pdp-player-personalization";
import productDetails from "./rbmc.pdp";

const pdpPreselect = {
    variantData:            undefined,
    variantSelector:        undefined,
    preselectedFlockName:   undefined,
    preselectedFlockNumber: undefined,
    preselectedIndividual:  undefined,
    urlString:              new URL(window.location.href),

    loadPreselectEngine() {
        //parameters extraction
        if (pdpPreselect.variantSelector.length) { //check if have more variants
            const preselectedVariantCode = pdpPreselect.urlString.searchParams.get('preselectedVariant');

            //1, load preselected variant if no flock selected
            if (preselectedVariantCode !== null && preselectedVariantCode !== '') {
                if (pdpPreselect.isVariantAvailable(preselectedVariantCode)) {
                    pdpPreselect.loadVariant(preselectedVariantCode);
                } else {
                    pdpPreselect.loadFirstAvailableProductVariant();
                }
            }

            //2, load preselected flock
            if (productDetails.productWithFlock &&
                    !productDetails.productFlockMandatory &&
                    pdpPreselect.preselectedFlockName.val() !== '' &&
                    pdpPreselect.preselectedFlockNumber.val() !== '') {
                if (pdpPreselect.preselectedIndividual.val() === 'true') {
                    pdpPreselect.loadCustomFlock(
                            pdpPreselect.preselectedFlockName,
                            pdpPreselect.preselectedFlockNumber
                    );
                } else {
                    pdpPreselect.loadPlayerFlock(
                            pdpPreselect.preselectedFlockNumber.val()
                    );
                }
            }
        }
    },

    loadFirstAvailableProductVariant() {
        const availableVariantOption = pdpPreselect.variantSelector
                                                   .find('option[data-out-of-stock="false"]:first');
        if (availableVariantOption.length) {
            pdpPreselect.variantSelector.prop(
                    'selectedIndex',
                    availableVariantOption.index()
            ).selectpicker('refresh');
            pdpLoadProduct.refreshVariantStatuses(
                    availableVariantOption.data('product-code'),
                    ['.pdp__stock-info', '.pdp__add-to-cart-button-wrapper']
            );
        } else {
            pdpPreselect.variantSelector.prop('selectedIndex', 0)
                        .selectpicker('refresh');
        }
    },

    isVariantAvailable(variantString) {
        const selection = pdpPreselect.variantSelector.find('option[data-product-code="' + variantString +'"]')
        return selection === undefined ? false : !selection.data('out-of-stock');
    },

    loadVariant(variantString) {
        pdpPreselect.variantSelector.prop(
                'selectedIndex',
                pdpPreselect.variantSelector
                            .find(`option[data-product-code="${variantString.toUpperCase()}"]`)
                            .index()
        ).selectpicker('refresh');
        pdpLoadProduct.refreshVariantStatuses(
                variantString,
                ['.pdp__stock-info', '.pdp__add-to-cart-button-wrapper']
        );
    },

    loadCustomFlock(name, number) {
        if (!pdpBlacklist.isBlacklisted(name.val())) {
            let checkSlick = setInterval(function () {
                if (pdpSlider.slickReady !== undefined) {
                    pdpCustomPersonalization.savePersonalizationFn(
                            true,
                            name,
                            number
                    );
                    clearTimeout(checkSlick);
                }
            }, 500);
        }
    },

    loadPlayerFlock(playerNumber) {
        let $playerSelect = $('#pdp__select-player'),
            selectedIndex = $playerSelect
                    .find(`option[data-num=${playerNumber}]`)
                    .index();
        pdpPlayerPersonalization.setPlayerPersonalization(selectedIndex);

        $playerSelect.prop('selectedIndex', selectedIndex)
                     .selectpicker('refresh');
    },

    init() {
        pdpPreselect.variantData            = $('#variantData');
        pdpPreselect.variantSelector        = $('#pdp__select-option');
        pdpPreselect.preselectedFlockName   = $('#preselected-flock-name');
        pdpPreselect.preselectedFlockNumber = $('#preselected-flock-number');
        pdpPreselect.preselectedIndividual  = $('#preselected-individual');
        pdpPreselect.loadPreselectEngine();

    }
};

export default pdpPreselect;
